<template>
  <!-- 仅做商品展示，不存在购买按钮 -->
  <div class="elementor-element elementor-element-80723d1 e-con-full container animated-fast e-flex e-con e-child animated fadeIn"
       data-id="80723d1"
       data-element_type="container"
       data-e-type="container"
       data-settings='{"background_background":"classic","animation":"fadeIn"}'>
    <div class="elementor-element elementor-element-0e8fd66 elementor-mobile-align-center elementor-widget-mobile__width-inherit elementor-align-center elementor-widget elementor-widget-button"
         data-id="0e8fd66"
         data-element_type="widget"
         data-e-type="widget"
         data-widget_type="button.default">
      <router-link class="elementor-button elementor-button-link elementor-size-sm"
                   to="/goods">
        <span class="elementor-button-content-wrapper">
          <span class="elementor-button-text">
            VIEW ALL
          </span>
        </span>
      </router-link>
    </div>
    <div class="elementor-element elementor-element-dd4c335 elementor-widget elementor-widget-jet-listing-grid"
         data-id="dd4c335"
         data-element_type="widget"
         data-e-type="widget"
         data-settings='{"columns":"4","columns_tablet":"3","columns_mobile":"1"}'
         data-widget_type="jet-listing-grid.default">
      <div class="jet-listing-grid jet-listing">
        <div class="jet-listing-grid__slider"
             dir="ltr">
          <div
               class="jet-listing-grid__items grid-col-desk-4 grid-col-tablet-3 grid-col-mobile-1 jet-listing-grid--200">
            <!-- 多列可见；每次向左平移一张卡片宽度，左侧卡片移出 -->
            <div class="crs-v"
                 @mouseenter="onPause"
                 @mouseleave="onResume">
              <div ref="crsTrack"
                   class="crs-t"
                   :style="trackStyle">
                <div v-for="(row, i) in extendedSlides"
                     :key="'c' + i"
                     class="jet-listing-grid__item crs-s">
                  <div data-elementor-type="jet-listing-items"
                       data-elementor-id="200"
                       class="elementor elementor-200"
                       data-elementor-post-type="jet-engine">
                    <div class="elementor-element elementor-element-e394b6b animated-fast e-flex e-con-boxed e-con e-parent e-lazyloaded animated fadeIn"
                         data-id="e394b6b"
                         data-element_type="container"
                         data-e-type="container"
                         data-settings='{"background_background":"classic","animation":"fadeIn"}'>
                      <div class="e-con-inner">
                        <div class="elementor-element elementor-element-9dd909d elementor-widget__width-inherit elementor-widget elementor-widget-image"
                             data-id="9dd909d"
                             data-element_type="widget"
                             data-e-type="widget"
                             data-widget_type="image.default">
                          <a target="_blank"
                             rel="nofollow noopener">
                            <img loading="lazy"
                                 decoding="async"
                                 width="300"
                                 height="300"
                                 :src="row.goodsImage"
                                 class="attachment-medium size-medium"
                                 alt="" />
                          </a>
                        </div>
                        <div class="elementor-element elementor-element-44282c1 elementor-widget elementor-widget-heading"
                             data-id="44282c1"
                             data-element_type="widget"
                             data-e-type="widget"
                             data-widget_type="heading.default">
                          <h3 class="elementor-heading-title elementor-size-default">
                            {{ row.goodsName }}
                          </h3>
                        </div>
                        <div class="elementor-element elementor-element-467247f elementor-widget elementor-widget-heading"
                             data-id="467247f"
                             data-element_type="widget"
                             data-e-type="widget"
                             data-widget_type="heading.default">
                          <div class="elementor-heading-title elementor-size-default">
                            {{ row.price }} {{ row.currencySymbol || '$' }}
                          </div>
                        </div>
                        <div class="elementor-element elementor-element-da84a8a elementor-align-justify elementor-widget__width-inherit elementor-widget elementor-widget-button"
                             data-id="da84a8a"
                             data-element_type="widget"
                             data-e-type="widget"
                             data-widget_type="button.default">
                          <a class="elementor-button elementor-button-link elementor-size-sm"
                             target="_blank"
                             rel="nofollow noopener">
                            <span class="elementor-button-content-wrapper">
                              <span class="elementor-button-text">
                                Buy on {{ selectPlatform.platformName }}
                              </span>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeType4Carousel',

  props: {
    goodsData: {
      type: Array,
      default: () => [],
    },

    selectPlatform: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      // 页面级状态集中在一个对象里，便于维护
      state: {
        scrollIndex: 0,
        noTrans: false,
        visible: 2,
        slideW: 267,
        slideGap: 8,
        paused: false,
        intervalMs: 1250,
        durationMs: 500,
        timer: null,
        /** 滑到克隆帧后延时跳回起点（不用 transitionend） */
        loopResetTimer: null,
        /** 实测相邻卡片间距（与 flex 布局一致），为 null 时用 slideW+slideGap */
        stepPx: null,
      },
    };
  },
  computed: {
    /**
     * 无缝循环：仅在末尾接上「前 visible 张」克隆，
     * scrollIndex 从 0 增到 n 时画面与 0 相同，再无动画回到 0（无前缀，避免错位闪跳）
     */
    extendedSlides() {
      const list = this.goodsData;
      const v = this.state.visible;
      const n = list.length;
      if (n < 2 || v >= n) {
        return list;
      }
      return list.concat(list.slice(0, v));
    },

    trackStyle() {
      const s = this.state;
      var step = s.stepPx != null && s.stepPx > 0 ? s.stepPx : s.slideW + s.slideGap;
      var tx = -s.scrollIndex * step;
      return {
        transform: 'translate3d(' + tx + 'px,0,0)',
        transition: s.noTrans ? 'none' : 'transform ' + s.durationMs + 'ms ease',
        gap: s.slideGap + 'px',
      };
    },
  },
  methods: {
    clearLoopResetTimer() {
      const st = this.state;
      if (st.loopResetTimer) {
        clearTimeout(st.loopResetTimer);
        st.loopResetTimer = null;
      }
    },
    /** 滑到 scrollIndex === n 时与第 0 帧相同，延时后无过渡跳回 0 */
    scheduleLoopReset(n) {
      var self = this;
      var st = this.state;
      this.clearLoopResetTimer();
      var delay = st.durationMs + 50;
      st.loopResetTimer = setTimeout(function () {
        st.loopResetTimer = null;
        if (self.state.scrollIndex !== n) {
          return;
        }
        st.noTrans = true;
        st.scrollIndex = 0;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            st.noTrans = false;
          });
        });
      }, delay);
    },
    tick() {
      const st = this.state;
      if (st.paused) {
        return;
      }
      const n = this.goodsData.length;
      const v = st.visible;
      if (n < 2 || v >= n) {
        return;
      }
      st.scrollIndex++;
      if (st.scrollIndex > n) {
        this.clearLoopResetTimer();
        st.noTrans = true;
        st.scrollIndex = 0;
        var self = this;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            self.state.noTrans = false;
          });
        });
        return;
      }
      if (st.scrollIndex === n) {
        this.scheduleLoopReset(n);
      }
    },
    resetScrollPos() {
      this.clearLoopResetTimer();
      var st = this.state;
      st.noTrans = true;
      st.scrollIndex = 0;
      var self = this;
      requestAnimationFrame(function () {
        self.state.noTrans = false;
      });
    },
    /** 用 DOM 实测步长，避免 flex/gap 与固定数不一致导致跳变 */
    measureStep() {
      var self = this;
      this.$nextTick(function () {
        var el = self.$refs.crsTrack;
        if (!el || el.children.length < 2) {
          return;
        }
        var c0 = el.children[0];
        var c1 = el.children[1];
        var dx = c1.offsetLeft - c0.offsetLeft;
        if (dx > 0) {
          self.state.stepPx = dx;
        }
      });
    },
    syncVisible() {
      const w = window.innerWidth;
      if (w < 768) {
        this.state.visible = 1;
      } else if (w < 1024) {
        this.state.visible = 3;
      } else {
        this.state.visible = 4;
      }
    },
    onResize() {
      this.syncVisible();
      this.state.stepPx = null;
      this.resetScrollPos();
      this.measureStep();
    },
    onPause() {
      this.state.paused = true;
    },
    onResume() {
      this.state.paused = false;
    },
  },
  mounted() {
    this.syncVisible();
    this.resetScrollPos();
    this.measureStep();
    window.addEventListener('resize', this.onResize);
    var st = this.state;
    if (this.goodsData.length >= 2 && st.visible < this.goodsData.length) {
      st.timer = setInterval(this.tick, st.intervalMs);
    }
  },
  beforeDestroy() {
    this.clearLoopResetTimer();
    window.removeEventListener('resize', this.onResize);
    if (this.state.timer) {
      clearInterval(this.state.timer);
      this.state.timer = null;
    }
  },
};
</script>

<style scoped>
/* crs：视口裁切；轨道按固定卡宽横向排布，translate 按「卡宽+间距」像素步进 */
.crs-v {
  overflow: hidden;
  width: 100%;
  padding: 0 50px;
  box-sizing: border-box;
}

.crs-t {
  display: flex;
  will-change: transform;
}

.crs-s {
  flex: 0 0 267px;
  width: 267px;
  min-width: 267px;
  box-sizing: border-box;
}

.elementor-200 .elementor-element.elementor-element-e394b6b:not(.elementor-motion-effects-element-type-background),
.elementor-200 .elementor-element.elementor-element-e394b6b>.elementor-motion-effects-container>.elementor-motion-effects-layer {
  box-shadow: 0px 0px 15px 0px var(--primary-color);
}

/* 维持原图 300×300 展示比例；Vue2 穿透子节点用 ::v-deep */
.crs-s ::v-deep img {
  width: 300px;
  max-width: 100%;
  height: auto;
  display: block;
}
</style>
